


export default {
    cptDataForm: {
        dataText: '{"value":"op1","options":[{"label":"选项1","value":"op1"},{"label":"选项2","value":"op2"},{"label":"选项3","value":"op3"}]}',
        apiUrl: '/tab', sql: 'select id from test limit 1',
        dataSource: 1, pollTime: -1,
    },
    attribute: {
        textColor: '#ffffff', fontWeight: 'normal', activeFontSize: 0, fontSize: 18, textFamily: '微软雅黑', lineHeight: 30, autoSwitch: false, interval: 3, activeColor: '#00ffed', backgroundColor: 'rgba(0, 0, 0, 0)', activeBg: 'rgba(0, 0, 0, 0)', activeTextFamily: '',
        isScroll: false, itemWidth: '', isFiexd: false, position: 'all', postitionX: 0, postitionY: 0, direction: 'row',
        switchTop: false, autoHeight: false, tabDefaultKey: '', tabDefaultURLKey: '',
        itemBackgroundColor: 'transparent',
        isOpenLayout: false,
        rowLeftNumber: 'unset', rowItemWidth: 'auto', rowMarginLeft: 0, rowMarginRight: 0, rowMarginTop: 0, rowMarginBottom: 0,
        columnTopNumber: 'unset', columnItemHeight: 'auto',
        tabStyleIndex: null,
        // tabStyleList: combinationTabStore.tabStyleList,
        textPositionY: 'center',
        textPositionX: 'center',
        enableGradual: 1,
        gradualColor: ['#54f857', '#f31794'],

        cptIndex: 1100000,
        cptFatherId: null,
        cptTabLevel: 1,

        templateRadioSize: 22
    },
    interaction: { multi: true }
}